import React from 'react'
import PrayerCalendar from '../../prayerSetting/PrayerCalendar'
import HijraOptions from '../HijraOptions'

type Props = {}

const HijraPage = (props: Props) => {
    return (
        <div className='flex'>
            <HijraOptions />
            <PrayerCalendar show={false} />
        </div>
    )
}

export default HijraPage